import type { Component } from 'vue'
import ComplianceDataAddress from './ComplianceDataAddress.vue'
import ComplianceDataBankDetail from './ComplianceDataBankDetail.vue'
import ComplianceDataBusinessEntity from './ComplianceDataBusinessEntity.vue'
import ComplianceDataClassification from './ComplianceDataClassification.vue'
import ComplianceDataField from './ComplianceDataField.vue'
import ComplianceDataFile from './ComplianceDataFile.vue'
import ComplianceDataGroup from './ComplianceDataGroup.vue'
import ComplianceDataRestrictedDocument from './ComplianceDataRestrictedDocument.vue'
import ComplianceDataStatus from './ComplianceDataStatus.vue'
import ComplianceDataDate from './ComplianceDataDate.vue'
import ComplianceDataUser from './ComplianceDataUser.vue'

export type ComplianceDataTypename =
  | 'ComplianceDataAddress'
  | 'ComplianceDataBankDetail'
  | 'ComplianceDataBusinessEntity'
  | 'ComplianceDataClassification'
  | 'ComplianceDataField'
  | 'ComplianceDataFile'
  | 'ComplianceDataGroup'
  | 'ComplianceDataRestrictedDocument'
  | 'ComplianceDataUser'
  | 'ComplianceDataStatus'
  | 'ComplianceDataDate'

const COMPONENT_BY_TYPENAME: Record<ComplianceDataTypename, Component> = {
  ComplianceDataAddress,
  ComplianceDataBankDetail,
  ComplianceDataBusinessEntity,
  ComplianceDataClassification,
  ComplianceDataField,
  ComplianceDataFile,
  ComplianceDataGroup,
  ComplianceDataRestrictedDocument,
  ComplianceDataUser,
  ComplianceDataStatus,
  ComplianceDataDate,
}

export function componentForComplianceDataEntry(type: ComplianceDataTypename): Component | null {
  return COMPONENT_BY_TYPENAME[type] ?? null
}
